import * as React from 'react'
import { Collapse } from 'reactstrap'
import DatePicker from 'react-datepicker'
import { es } from 'date-fns/esm/locale'
import { useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import composerActions from '../../../../redux/actions/conversations/composerAct'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { InputControls } from 'components/common'

class DaySelector extends React.Component {
  render() {
    const { value, onClick } = this.props
    return (
      <div className='selector' onClick={onClick}>
        {value}
        <i className={`fa fa-calendar-o fa-lg`} />
      </div>
    )
  }
}

const PluginProgramMessage = (props) => {
  const open = props.composer.isDeferred
  const [startDate, setStartDate] = React.useState(new Date())
  const maxTimeDate = new Date().setHours(23,59)
  const dispatch = useDispatch()

  const setDateAndTime = (date = null) => {
    const pickerDate = date ? date : startDate
    const dateString = new Date(pickerDate)
      .toISOString()
    dispatch(composerActions.setDeferredDate(dateString))
  }

  const togglePlugin = (state) => {
    dispatch(composerActions.toggleDeferred(state))
    setDateAndTime()
  }

  const selectDate = (date) => {
    setStartDate(date)
    setDateAndTime(date)
  }

  const isToday = (someDate) => {
    const today = new Date()
    return someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
  }

  return (
    <div
      className={!open ? 'plugin-card' : 'plugin-card-enabled'}
      style={{ marginLeft: !open ? '10px' : null }}
    >
      <div className='switch-container'>
        <div className={`title ${props.isRemoveByUser ? 'disabled' : ''}`}>
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-clock-dark.svg')} alt={I18n.t('deferred_plugin_title')} />
          </figure>
          <p>{I18n.t('deferred_plugin_title')}</p>
        </div>
        <InputControls
          injectType={'external'}
          value={open}
          onChange={() => togglePlugin(!open)}
          disabled={props.isRemoveByUser ? true : false}
        />
      </div>
      <Collapse isOpen={open}>
        <div className='separator'/>
        <div className='config-schedule-container'>
          <div className='schedule-day'>
            {I18n.t('deferred_plugin_subtitle')}
            <DatePicker
              selected={startDate}
              onChange={date => selectDate(date)}
              customInput={<DaySelector />}
              locale={es}
              dateFormat="MMMM d HH:mm"
              showTimeSelect
              timeIntervals={15}
              minDate={new Date()}
              minTime={isToday(startDate) ? startDate : null}
              maxTime={isToday(startDate) ? maxTimeDate : null}
            />
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default PluginProgramMessage